import {Mark} from "../TextHighlighter";

export default class TextSelection {
    constructor(
        public mark: Mark,
        public comment: null|string = null,
    ) { }

}